import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { rgba } from 'polished';
import {
    Colours,
    Sizes,
    Typography,
    IconCheckmark,
    Caption,
} from '@ratehub/base-ui';


function SuccessBlock({ title, ...otherProps }) {
    return (
        <SuccessBlock.FlexContainer {...otherProps}>
            <SuccessBlock.IconCheckmark
                width={Sizes.ICONS.XS}
                height={Sizes.ICONS.XS}
                stroke={Colours.COCONUT}
                outlineWidth="3px"
                strokeWidth="3px"
            />
            <SuccessBlock.Title variant="light">
                {title}
            </SuccessBlock.Title>
        </SuccessBlock.FlexContainer>
    );
}

SuccessBlock.propTypes = {
    title: PropTypes.string.isRequired,
};


SuccessBlock.FlexContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    padding: ${Sizes.SPACING.HALF};
    background-color: ${rgba(Colours.LIME, 0.97)};
`;

SuccessBlock.Title = styled(Caption)`
    margin: 0;
    text-align: left;
    font-weight: ${Typography.WEIGHTS.MEDIUM};
`;

SuccessBlock.IconCheckmark = styled(IconCheckmark)`
    flex: ${Sizes.SPACING.TWO_AND_A_HALF} 0 0;
`;


export default observer(SuccessBlock);
